<template>
  <div class="deliveryGoods-mian">
    <el-steps class="deliveryGoods-steps" direction="vertical" :space="80">
      <el-step title="粘贴箱唛">
        <template v-slot:description>
          <div class="steps-box">
            <span>为确保仓库正常签收您交运的货物，请</span>
            <el-button class="steps-box-btn" @click="printCartonLabel">打印箱唛</el-button>
            <span>并贴在每件货物外箱的侧面</span>
          </div>
        </template>
      </el-step>
      <el-step title="货件交仓">
        <template v-slot:description>
          <div class="steps-box">
            <span>上门取件或自送到仓，均需</span>
            <el-button class="steps-box-btn" @click="exportInWarehouseOrder">打印入仓单</el-button>
            <span>并随货提供给仓库</span>
          </div>
          <div class="steps-box margin-top_15">
            <img src="@/assets/img/client/booking/deliveryGoods-right-icon.png" width="12" height="12">
            <span class="margin-left_10">如需上门取件，请联系平台客服预约取件。</span>
          </div>
          <div class="steps-box margin-top_15">
            <img src="@/assets/img/client/booking/deliveryGoods-right-icon.png" width="12" height="12">
            <span class="margin-left_10">自送到仓，如使用快递寄送请填写</span>
            <el-button class="steps-box-btn" @click="warehouseNumber">送仓单号</el-button>
          </div>
          <div class="address-info margin-top_10">
            <div class="address-info-title">送仓地址信息</div>
            <div class="address-info-item">
              <div>联系人：</div>
              <div>{{ warehouseInfo.personCharge }}</div>
            </div>
            <div class="address-info-item">
              <div>联系电话：</div>
              <div>{{ warehouseInfo.personPhone }}</div>
            </div>
            <div class="address-info-item">
              <div>仓库地址：</div>
              <div>{{ warehouseInfo.wareAddress }}</div>
            </div>
          </div>
        </template>
      </el-step>
    </el-steps>

    <el-dialog
      title="送仓单号"
      lock-scroll
      class="dialog_center"
      :visible.sync="isWarehouseOrderNoDialog"
      :top="'0'"
      :before-close="closeWarehouseOrderNo"
      :append-to-body="true"
    >
      <div class="margin-bottom_15">如您的货物使用快递寄件到仓，填写后我们将为您跟进送仓情况</div>
      <el-form ref="form" class="companyAndOrderNo" :model="formData" :rules="rules" label-position="top">
        <div class="companyAndOrderNo-container">
          <div v-for="(item,index) in formData.companyAndOrderNoList" class="companyAndOrderNo-item">
            <el-form-item
              class="companyAndOrderNo-form-item"
              :prop="`companyAndOrderNoList[${index}].expressCompany`"
              :rules="rules.expressCompany"
            >
              <el-select v-model="item.expressCompany">
                <el-option
                  v-for="(item,index) in expressCompanyOptions"
                  :key="index"
                  :label="item.fullName"
                  :value="item.enCode"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              class="companyAndOrderNo-form-item"
              style="width: 70%;"
              :prop="`companyAndOrderNoList[${index}].trackingNo`"
              :rules="rules.trackingNo"
            >
              <el-input v-model="item.trackingNo" class="form-orderNo" placeholder="请输入快递单号" />
            </el-form-item>

            <el-button
              v-if="formData.companyAndOrderNoList.length > 1"
              class="margin-left_10"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteCompanyAndOrderNo(index)"
            />
          </div>
        </div>
        <el-button class="form-add-btn" @click="addCompanyAndOrderNo">+ 新增</el-button>
      </el-form>
      <div class="margin-top_15 form-operation">
        <el-button @click="closeWarehouseOrderNo">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submit">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Dialog from '@/components/Dialog/Dialog.vue'
import request from '@/utils/request'
import {
  getCookie
} from '@/utils/cookiejs'
import {
  getDictionaryDataSelector
} from '@/api/dictionary'
export default {
  name: 'Index',
  components: {
    Dialog
  },
  props: {

  },
  data() {
    return {
      isWarehouseOrderNoDialog: false,
      warehouseInfo: {},
      expressCompanyOptions: [],
      btnLoading: false,
      formData: {
        companyAndOrderNoList: [{
          expressCompany: '',
          trackingNo: ''
        }]
      },
      rules: {
        expressCompany: [{
          required: true,
          message: '请选择快递公司',
          trigger: 'change'
        }],
        trackingNo: [{
          required: true,
          message: '请输入快递单号',
          trigger: 'blur'
        }]
      },
      data: {}
    }
  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    exportInWarehouseOrder() {
      request({
        url: `api/wms/template/getSceneTemplate/inwarehouse_export_tpl`,
        method: 'GET'
      }).then(res => {
        if (res.code == 200 && res.data.length > 0) {
          var templateId = res.data[0].id
          request({
            url: `/api/wms/warehouse/ExportInWarehouseOrder`,
            method: 'GET',
            headers: {
              'Authorization': this.token
            },
            data: {
              orderNo: this.data.orderNo,
              templateId: templateId
            }
          }).then((res1) => {
            if (res1.code == 200 && res1.data != null) {
              this.xms.downloadFile(res1.data.url)
            }
          })
        }
      })
    },
    init(data) {
      this.data = data
      this.getGoodsWarehouse(data.warehouseId)
      getDictionaryDataSelector('ExpressCompany').then(res => {
        this.expressCompanyOptions = res.data.list
      })
    },
    validate(rule, value, callback) {
      var err = false
      this.formData.companyAndOrderNoList.forEach(item => {
        if (!item.expressCompany || !item.trackingNo) {
          err = true
          return
        }
      })
      if (err) {
        callback(new Error('单号信息填写不完整'))
      } else {
        callback()
      }
    },
    printCartonLabel() {
      request({
        url: `/api/webapi/Order/GetMarkUrl`,
        method: 'GET',
        headers: {
          'Authorization': getCookie('token')
        },
        data: {
          id: this.data.orderNo
        }
      }).then((res) => {
        if (res.code == 200 && res.data != null) {
          this.xms.downloadFile(res.data)
        }
      })
    },
    warehouseNumber() {
      this.isWarehouseOrderNoDialog = true
    },
    closeWarehouseOrderNo() {
      this.isWarehouseOrderNoDialog = false
    },
    addCompanyAndOrderNo() {
      this.formData.companyAndOrderNoList.push({
        company: '',
        orderNo: ''
      })
    },
    deleteCompanyAndOrderNo(index) {
      this.formData.companyAndOrderNoList.splice(index, 1)
    },
    getGoodsWarehouse(warehouseId) {
      request({
        url: `/api/wms/warehouse/` + warehouseId,
        method: 'get',
        headers: {
          'Authorization': getCookie('token')
        }
      }).then(res => {
        this.warehouseInfo = res.data
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: `/api/Wms/OrderTrackingNo`,
            method: 'put',
            data: {
              orderNo: this.data.orderNo,
              list: this.formData.companyAndOrderNoList
            }
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1000
              })
              this.isWarehouseOrderNoDialog = false
            }
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
	.deliveryGoods-mian {
		width: 100%;
		background: #ffffff;
		border-radius: 10px;
		margin: 16px 0;
		padding: 20px;
		box-sizing: border-box;

		.deliveryGoods-steps {
			::v-deep .el-step__icon {
				background: #3370FF;
				color: #ffffff;
				border: none;
			}

			::v-deep .el-step__title {
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}

			::v-deep .el-step__description {
				color: #8E8E89;
				font-size: 12px;
			}

			.steps-box {
				display: flex;
				align-items: center;

				.steps-box-btn {
					width: 89px;
					height: 36px;
					border-radius: 6px;
					font-size: 14px;
					border: 1px solid #C5D1F8;
					background: #EEF1FA;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #436FF6;
					margin: 0 5px;
				}
			}

			.address-info {
				width: 100%;
				background: #F6F8FA;
				border-radius: 10px;
				padding: 15px 20px;
				box-sizing: border-box;

				.address-info-title {
					color: #000000;
					font-size: 14px;
					font-weight: 500;
				}

				.address-info-item {
					display: flex;
					font-size: 14px;

					div:nth-child(1) {
						width: 80px;
					}

					div:nth-child(2) {
						color: #000000;
					}
				}

				.address-info-item:nth-child(1),
				.address-info-item:nth-child(2),
				.address-info-item:nth-child(3) {
					margin: 20px 0;
				}
			}

		}
	}

	.companyAndOrderNo {
		.companyAndOrderNo-container {
			max-height: 200px;
			overflow: auto;
		}

		.companyAndOrderNo-item {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.companyAndOrderNo-form-item:nth-child(2) {
				width: 70%;
				margin-left: 10px;
			}

			.form-orderNo {
				width: 100%;
			}
		}

		.form-add-btn {
			width: 100%;
			margin-top: 5px;
			border: 1px dashed #c5c5c5;
		}
	}

	.form-operation {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog_center {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
